/**
 * Resolves post–sign-in redirect: React Router `state.from` or `returnTo` / `from`
 * query params. Blocks open redirects and auth routes. Defaults to `/` (home).
 */

const AUTH_PATH_PREFIXES = [
  "/client/signin",
  "/signup",
  "/forgot-password",
  "/reset-password",
  "/change-password",
];

function pathnameOnly(path) {
  const q = path.indexOf("?");
  const h = path.indexOf("#");
  let end = path.length;
  if (q >= 0) end = Math.min(end, q);
  if (h >= 0) end = Math.min(end, h);
  return path.slice(0, end);
}

function isAuthPath(pathname) {
  return AUTH_PATH_PREFIXES.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );
}

function isSafeInternalPath(path) {
  if (!path || typeof path !== "string") return false;
  if (!path.startsWith("/") || path.startsWith("//")) return false;
  const base = pathnameOnly(path);
  if (isAuthPath(base)) return false;
  return true;
}

function pathFromLocation(from) {
  return from.pathname + (from.search || "") + (from.hash || "");
}

export function resolveSafeReturnPath(locationState, searchParams, fallback = "/") {
  const state = locationState;
  if (state?.from && typeof state.from.pathname === "string") {
    const full = pathFromLocation(state.from);
    if (isSafeInternalPath(full)) return full;
  }

  const q = searchParams.get("returnTo") || searchParams.get("from");
  if (q) {
    try {
      const decoded = decodeURIComponent(q);
      if (isSafeInternalPath(decoded)) return decoded;
    } catch {
      // ignore malformed encoding
    }
  }

  return fallback;
}
